<template>
  <div>
    <MobileNavigation></MobileNavigation>
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 bg-slate-900 p-2" style="height:100%">
        <br><br>       
     <div>
  <div class="accordion-option">

  <div class="panel-group drop-shadow-sm" id="accordion" role="tablist" aria-multiselectable="true">
    <div class="panel panel-default">
      <div class="panel-heading" role="tab" id="headingOne">
        <h4 class="panel-title">
        <a role="button" class="no-decoration bg-white text-black" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
          <div class="grid grid-cols-9 gap-1 p-2 rounded-lg ">
            <div class="text-center">
              <div class="text-center w-12 h-12 mt-1 pt-2 bg-blue-500 text-white rounded-sm">A</div>
            </div>
            <div class="col-span-7">      
              <span class="text-xl">Some Heading</span><br>
              <span class="text-lg">Some text here</span>
            </div>
            <div class="text-right ">
              <i class="far fa-heart"></i>
            </div>

        </div>
        </a>
      </h4>
      </div>
      <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
        <div class="panel-body">
          <div class="grid grid-cols-6 gap-1 text-center">
            <i class="fab fa-whatsapp text-xl"></i>
            <i class="fas fa-phone-alt text-xl"></i>
            <i class="fas fa-sms text-xl"></i>
            <i class="fab fa-stripe-s text-xl"></i>
            <i class="fas fa-calendar-check text-xl"></i>
            <i class="fas fa-map-marker-alt text-xl"></i>
          </div>
          
            <div class="mt-1 p-1 bg-gray-200">
              <table>
                <tr class="p-1">
                  <td>
                    Name : 
                  </td>
                  <td>
                    Some Text
                  </td>
                </tr>
                <tr class="p-1">
                  <td>
                    Name : 
                  </td>
                  <td>
                    Some Text
                  </td>
                </tr>
                <tr class="p-1">
                  <td>
                    Name : 
                  </td>
                  <td>
                    Some Text
                  </td>
                </tr>

              </table>
            </div>

        </div>
      </div>
    </div>
    
  </div>
</div>
</div>
      </div>
  </div>
</template>
<style scoped>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }

    .no-decoration{
      text-decoration: none;
      color: black;
    }

    .no-decoration:focus{
      text-decoration: none;
      color: black;

    }

    .no-decoration:hover{
      text-decoration: none;
      color: black;
    }

.panel-default>.panel-heading {
  color: #333;
  background-color: #fff;
  border-color: #e4e5e7;
  padding: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.panel-default>.panel-heading a {
  display: block;
  padding: 10px 15px;
}

.panel-default>.panel-heading a:after {
  content: "";
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: 'Glyphicons Halflings';
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  float: right;
  transition: transform .25s linear;
  -webkit-transition: -webkit-transform .25s linear;
}

.panel-default>.panel-heading a[aria-expanded="true"] {
  background-color: #eee;
}

.panel-default>.panel-heading a[aria-expanded="true"]:after {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.panel-default>.panel-heading a[aria-expanded="false"]:after {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.accordion-option {
  width: 100%;
  float: left;
  clear: both;
  margin: 15px 0;
}

.accordion-option .title {
  font-size: 20px;
  font-weight: bold;
  float: left;
  padding: 0;
  margin: 0;
}

.accordion-option .toggle-accordion {
  float: right;
  font-size: 16px;
  color: #6a6c6f;
}

.accordion-option .toggle-accordion:before {
  content: "Expand All";
}

.accordion-option .toggle-accordion.active:before {
  content: "Collapse All";
}

    </style>

<script>
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'

export default {
  props: ["sessions"],

  components: {
    MobileNavigation,
    Welcome,
    PageTitle,
    JetNavLink,
  },
  data() {
    return {
      title: "Attendance Menu",
      username: null,
      password: null,

    };
  },
  methods: {
    setList() {

  $(".toggle-accordion").on("click", function() {
    var accordionId = $(this).attr("accordion-id"),
      numPanelOpen = $(accordionId + ' .collapse.in').length;
    
    $(this).toggleClass("active");

    if (numPanelOpen == 0) {
      openAllPanels(accordionId);
    } else {
      closeAllPanels(accordionId);
    }
  })

  openAllPanels = function(aId) {
    console.log("setAllPanelOpen");
    $(aId + ' .panel-collapse:not(".in")').collapse('show');
  }
  closeAllPanels = function(aId) {
    console.log("setAllPanelclose");
    $(aId + ' .panel-collapse.in').collapse('hide');
  }
     
    },
  },
  mounted() {
    this.setList();    
  },
};
</script>
